<template>
    <el-dialog ref="dialogDeleteTag" class="dialog-body-wrap zimbra-dialog"
               custom-class="modal-add__tag"
               :title="$t('zimbra.zmMsg.confirmDeleteApptTitle')"
               :visible.sync="dialogDeleteTag"
               width="360px"
               :append-to-body="true"
               :close-on-click-modal="false">
        <el-form class="form-wrap pt-5">
            <span class="label-custom">{{ $t("zimbra.zmMsg.confirmDeleteTag") }}</span>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button class="btn-email default cover-size-cancel" @click="dialogDeleteTag = false">{{$t("zimbra.zmMsg.none")}}</el-button>
            <el-button class="btn-email primary cover-size-delete" @click="deleteTag">{{$t("zimbra.zmMsg.removeTag")}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import CommonUtils from "../../../../utils/common-utils";
import { mapGetters } from "vuex";
import _ from "lodash";
import ZimbraMailService from "../../../../services/ZimbraMailService";
import { FOLDER_DEFAULT, STATUS_REQUEST } from "../../../../utils/constants";

export default {
    mixins: [CommonUtils],
    computed: {
        ...mapGetters(["listTag"])
    },

    mounted() {
        this.$root.$on("handleTagActionDelete", (data) => {
            this.show(data);
        });
    },

    data() {
        return {
            treeNodeData: {},
            dialogDeleteTag: false
        };
    },

    methods: {
        show(treeNodeData) {
            this.treeNodeData = treeNodeData;
            this.dialogDeleteTag = true;
        },

        deleteTag() {
            const form = {
                tag: `<urn1:action id="${this.treeNodeData.id}" op="delete"></urn1:action>`
            };
            ZimbraMailService.tagActionRequest(form).then((res) => {
                if (res.status === STATUS_REQUEST.SUCCESS) {
                    if (this.isMessage) {
                        this.$message({
                            type: "success",
                            customClass: "zm-notify",
                            duration: 3500,
                            dangerouslyUseHTMLString: true,
                            message: this.$t("zimbraNokey.zimbra_sidebar_messageSuccessDeleteTag")
                        });
                    } else {
                        this.$notify({
                            title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                            message: this.$t("zimbraNokey.zimbra_sidebar_messageSuccessDeleteTag"),
                            type: "success",
                            position: 'bottom-right',
                        });
                    }

                    this.treeNodeData.l = FOLDER_DEFAULT.TAG;
                    const listTag = _.cloneDeep(this.listTag).filter(x => x.id !== this.treeNodeData.id);
                    this.$store.commit("SET_LIST_TAG", listTag);
                    this.$root.$emit(
                        "deleteItemToDataExtend",
                        this.treeNodeData
                    );
                }
            });
            this.dialogDeleteTag = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.mb-8 {
    margin-bottom: 8px;
}

.pt-5 {
    padding-top: 5px !important;
}

.label-custom {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}

::v-deep {
    .el-dialog__header {
        border: 1px solid #DEE2E6 !important;
        background: #f7f7f7;
        padding: 12px 16px 12px 16px !important;
        border-radius: 12px 12px 0 0;
        word-break: break-all;
    }

    .el-dialog__header .el-dialog__title {
        font-weight: 600 !important;
        font-size: 16px !important;
        line-height: 24px !important;
        color: #212529 !important;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: #2f384c !important;
        width: 32px !important;
        height: 32px !important;
        padding: 6px !important; ;
    }

    .el-dialog__headerbtn:hover .el-dialog__close {
        color: #409eff !important;
    }

    .el-dialog__footer {
        padding: 12px 16px 12px 16px !important;
        text-align: right;
        box-sizing: border-box;
        border-top: 1px solid #DEE2E6;
    }

    .btn-email {
        font-weight: 600 !important;
        font-size: 14px !important;
    }

    .el-dialog__footer .dialog-footer .btn-email.primary {
        padding: 10px 13px !important;
    }
}

.cover-size-cancel {
    height: 32px !important;
    border-radius: 8px !important;
    padding: 6px 12px 6px 12px !important;
    box-shadow: 0 -1px 0 #E3E3E3, 1px 0 0 #E3E3E3, -1px 0 0 #E3E3E3, 0 -1px 0 #B5B5B5;
}

.cover-size-delete {
    height: 32px !important;
    border-radius: 8px !important;
}
</style>
